import type { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    children: ReactNode;
    variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
    busy?: boolean;
};

export default function Button({ children, className = '', variant = 'primary', type = 'button', busy = false, disabled, ...props }: ButtonProps) {
    return <button {...props} className={`button button-${variant} ${className}`.trim()} type={type} disabled={disabled || busy} aria-busy={busy || undefined}>
        {busy && <span className="spinner" aria-hidden="true" />}
        {children}
    </button>;
}
